"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPostMessage = void 0;
var sendPostMessage = function sendPostMessage(message, parentDomain) {
  window.parent.postMessage(message, parentDomain);
};
exports.sendPostMessage = sendPostMessage;
//# sourceMappingURL=sender.js.map